export default __webpack_public_path__ + "static/media/icon4.c49bbb30.png";